import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import FloatingButtons from '@/pages/home/components/FloatingButtons';
import ProgressiveImage from '@/components/base/ProgressiveImage';

const stats = [
  { value: '50+', label: 'Yıllık Deneyim', icon: 'ri-award-line' },
  { value: '27', label: 'Avrupa Ülkesi', icon: 'ri-global-line' },
  { value: '500+', label: 'Mutlu Müşteri', icon: 'ri-emotion-happy-line' },
  { value: '7/24', label: 'Aktif Destek', icon: 'ri-headphone-line' },
];

const advantages = [
  {
    number: '01',
    icon: 'ri-heart-2-line',
    title: 'Aile Firması Güvencesi',
    desc: '1975\'ten bu yana baba-oğul ortaklığıyla hizmet veriyoruz. Her müşterimize aile gibi yaklaşıyor, işini sahipleniyoruz. Büyük şirketlerin soğuk hizmetinden değil, gerçek ilgiden yanayız.',
    image: '/media/search-image-89703d7bb7.jpg',
  },
  {
    number: '02',
    icon: 'ri-shield-check-line',
    title: 'Sigortalı & Güvenli Taşıma',
    desc: 'Tüm yükleriniz kapsamlı CMR sigortası güvencesi altında taşınır. Hasar durumunda tam tazminat garantisi veriyoruz. Eşyalarınız bizim için emanet — bunu ciddiye alıyoruz.',
    image: '/media/search-image-11c8212785.jpg',
  },
  {
    number: '03',
    icon: 'ri-map-pin-2-line',
    title: 'Kapıdan Kapıya Teslimat',
    desc: 'Türkiye\'nin 81 ilinden Avrupa\'nın 27 ülkesine — eşyalarınızı kapınızdan alıp yeni adresinize kurulum dahil teslim ediyoruz. Siz sadece anahtarı teslim alın.',
    image: '/media/search-image-e5fd6fd294.jpg',
  },
  {
    number: '04',
    icon: 'ri-money-euro-circle-line',
    title: 'Şeffaf & Dürüst Fiyat',
    desc: 'Gizli ücret yok, sürpriz fatura yok. Fiyat teklifinizi önceden öğrenin, ödemeyi teslimatta yapın. 50 yıldır aynı dürüstlükle çalışıyoruz — bu bizi rakiplerimizden ayıran en önemli fark.',
    image: '/media/search-image-5126b586a5.jpg',
  },
];

const countries = [
  'Almanya', 'Fransa', 'Hollanda', 'Belçika', 'Avusturya', 'İsviçre',
  'İtalya', 'İspanya', 'Portekiz', 'İsveç', 'Norveç', 'Danimarka',
  'Finlandiya', 'Polonya', 'Çekya', 'Slovakya', 'Macaristan', 'Romanya',
  'Bulgaristan', 'Yunanistan', 'Hırvatistan', 'Slovenya', 'Lüksemburg', 'İrlanda',
  'Estonya', 'Letonya', 'Litvanya',
];

function Hero() {
  return (
    <section className="relative overflow-hidden bg-brand-navy" style={{ minHeight: '92vh' }}>
      <div className="absolute inset-0">
        <ProgressiveImage
          src="/media/search-image-25263579c2.jpg"
          alt="Neden Töle Lojistik"
          className="object-cover object-center"
          priority
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-center" style={{ paddingTop: '9rem', paddingBottom: '6rem', minHeight: '92vh' }}>
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 mb-10">
          <Link to="/" className="text-white/40 text-xs hover:text-white transition-colors">Anasayfa</Link>
          <span className="text-white/20 text-xs">/</span>
          <span className="text-brand-orange text-xs font-medium">Neden Biz?</span>
        </div>

        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 border border-brand-orange/40 text-brand-orange px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-widest mb-8">
            <span className="w-1.5 h-1.5 bg-brand-orange rounded-full animate-pulse"></span>
            1975&apos;ten Bugüne
          </div>

          <h1 className="text-white font-heading font-bold text-5xl md:text-6xl lg:text-7xl leading-[1.05] mb-8 tracking-tight">
            Neden<br />
            <span className="text-brand-orange">Töle</span><br />
            Lojistik?
          </h1>

          <p className="text-white/60 text-lg md:text-xl leading-relaxed max-w-xl mb-12">
            50 yıllık deneyim, aile güvencesi ve şeffaf fiyatlandırmayla Türkiye&apos;den Avrupa&apos;ya en güvenilir lojistik çözüm.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://wa.me/905322376576?text=Merhaba%2C%20fiyat%20teklifi%20almak%20istiyorum."
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-brand-orange hover:bg-brand-orange-dark text-white px-7 py-3.5 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-line text-base"></i></span>
              Hemen Fiyat Al
            </a>
            <Link
              to="/iletisim"
              className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/25 hover:bg-white/20 text-white px-7 py-3.5 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-send-line text-base"></i></span>
              İletişime Geç
            </Link>
          </div>
        </div>

        {/* Stats bar */}
        <div className="mt-16 pt-10 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label} className="flex items-center gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-brand-orange/20 text-brand-orange rounded-xl flex-shrink-0">
                <i className={`${s.icon} text-lg`}></i>
              </div>
              <div>
                <div className="text-white font-heading font-bold text-2xl leading-none">{s.value}</div>
                <div className="text-white/40 text-xs mt-1">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function AdvantagesSection() {
  const [active, setActive] = useState(0);
  const item = advantages[active];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Farkımız</p>
          <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl">Bizi Tercih Etmeniz İçin<br />4 Güçlü Neden</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* Sol: Seçim listesi */}
          <div className="flex flex-col gap-3">
            {advantages.map((adv, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`text-left w-full rounded-2xl p-6 transition-all duration-300 cursor-pointer border ${
                  active === i
                    ? 'bg-brand-navy border-brand-navy'
                    : 'bg-white border-gray-100 hover:border-gray-200'
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className={`w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0 transition-all duration-300 ${
                    active === i ? 'bg-brand-orange text-white' : 'bg-brand-orange/10 text-brand-orange'
                  }`}>
                    <i className={`${adv.icon} text-xl`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className={`text-xs font-bold uppercase tracking-widest mb-1 ${active === i ? 'text-brand-orange' : 'text-gray-400'}`}>
                      {adv.number}
                    </div>
                    <h3 className={`font-heading font-bold text-base mb-1 ${active === i ? 'text-white' : 'text-brand-navy'}`}>
                      {adv.title}
                    </h3>
                    {active === i && (
                      <p className="text-white/60 text-sm leading-relaxed mt-2">{adv.desc}</p>
                    )}
                  </div>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                    active === i ? 'text-brand-orange' : 'text-gray-300'
                  }`}>
                    <i className={`ri-arrow-right-s-line text-xl transition-transform duration-300 ${active === i ? 'rotate-90' : ''}`}></i>
                  </div>
                </div>
              </button>
            ))}
          </div>

          {/* Sağ: Görsel */}
          <div className="lg:sticky lg:top-28">
            <div className="relative rounded-2xl overflow-hidden h-[380px] md:h-[480px]">
              <ProgressiveImage
                key={item.image}
                src={item.image}
                alt={item.title}
                className="object-cover object-center transition-opacity duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent pointer-events-none"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/95 rounded-xl p-4 flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-brand-orange text-white rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <div>
                    <div className="text-brand-navy font-heading font-bold text-sm">{item.title}</div>
                    <div className="text-gray-400 text-xs mt-0.5">Töle Lojistik Farkı</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function TimelineSection() {
  const milestones = [
    { year: '1975', title: 'Kuruluş', desc: 'Töle ailesi, Türkiye\'de lojistik sektörüne ilk adımını attı. Küçük bir araçla başlayan yolculuk, büyük bir vizyonla şekillendi.' },
    { year: '1990', title: 'Avrupa\'ya Açılış', desc: 'Almanya\'ya ilk düzenli sefer başlatıldı. Türkiye-Almanya hattında güvenilir bir isim olarak tanınmaya başlandı.' },
    { year: '2005', title: 'Depo Yatırımı', desc: 'Almanya\'da merkez depo kuruldu. Tüm Avrupa\'ya dağıtım kapasitesi büyük ölçüde arttı.' },
    { year: '2015', title: '2. Nesil', desc: 'Baba-oğul ortaklığı güçlendi. Dijital altyapı ve müşteri hizmetleri modernize edildi.' },
    { year: '2024', title: 'Bugün', desc: '27 Avrupa ülkesine hizmet, 500+ mutlu müşteri ve 50 yıllık deneyimle sektörün en güvenilir ismi.' },
  ];

  return (
    <section className="py-24 bg-gray-50/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Sol: Görsel */}
          <div className="relative rounded-2xl overflow-hidden h-[420px] md:h-[540px]">
            <ProgressiveImage
              src="/media/search-image-55c564499d.jpg"
              alt="50 Yıllık Yolculuk"
              className="object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <div className="bg-brand-navy/90 backdrop-blur-sm rounded-xl p-5 border border-white/10">
                <div className="text-brand-orange font-heading font-bold text-3xl mb-1">1975 – 2025</div>
                <div className="text-white text-sm font-medium">50 Yıllık Güven Yolculuğu</div>
                <div className="text-white/50 text-xs mt-1">Babadan oğula, aynı değerler</div>
              </div>
            </div>
          </div>

          {/* Sağ: Timeline */}
          <div>
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Tarihçemiz</p>
            <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-10">50 Yıllık<br />Güven Yolculuğu</h2>

            <div className="relative">
              {/* Dikey çizgi */}
              <div className="absolute left-5 top-0 bottom-0 w-px bg-gray-200"></div>

              <div className="flex flex-col gap-0">
                {milestones.map((m, i) => (
                  <div key={i} className="flex gap-6 pb-8 last:pb-0 relative">
                    {/* Nokta */}
                    <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 z-10 border-2 ${
                      i === milestones.length - 1
                        ? 'bg-brand-orange border-brand-orange text-white'
                        : 'bg-white border-gray-200 text-brand-navy'
                    }`}>
                      {i === milestones.length - 1
                        ? <i className="ri-star-fill text-sm"></i>
                        : <i className="ri-checkbox-blank-circle-fill text-xs text-gray-300"></i>
                      }
                    </div>
                    <div className="pt-1.5">
                      <div className="flex items-center gap-3 mb-1">
                        <span className={`font-heading font-bold text-lg ${i === milestones.length - 1 ? 'text-brand-orange' : 'text-brand-navy'}`}>
                          {m.year}
                        </span>
                        <span className="text-brand-navy font-semibold text-sm">{m.title}</span>
                      </div>
                      <p className="text-gray-400 text-sm leading-relaxed">{m.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function CountriesSection() {
  return (
    <section className="py-24 bg-brand-navy overflow-hidden relative">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, #DC2626 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Hizmet Ağımız</p>
          <h2 className="text-white font-heading font-bold text-3xl md:text-4xl mb-4">
            Avrupa&apos;nın <span className="text-brand-orange">27 Ülkesine</span> Teslimat
          </h2>
          <p className="text-white/50 text-sm max-w-lg mx-auto">
            Almanya&apos;daki merkez depomuzdan tüm Avrupa&apos;ya düzenli seferler düzenliyoruz.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 mb-14">
          {countries.map((country, i) => (
            <div
              key={i}
              className="flex items-center gap-2 bg-white/8 border border-white/10 text-white/80 px-4 py-2 rounded-full text-sm font-medium hover:bg-brand-orange/20 hover:border-brand-orange/30 hover:text-white transition-all duration-200 cursor-default"
            >
              <span className="w-1.5 h-1.5 bg-brand-orange rounded-full flex-shrink-0"></span>
              {country}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-heading font-bold text-xl md:text-2xl mb-2">
              Ülkenize Teslimat Yapıyor Muyuz?
            </h3>
            <p className="text-white/50 text-sm">
              Listede görmediğiniz bir ülke için de bize ulaşın — çözüm buluruz.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <a
              href="https://wa.me/905322376576?text=Merhaba%2C%20teslimat%20yapabildi%C4%9Finiz%20%C3%BClkeleri%20%C3%B6%C4%9Frenmek%20istiyorum."
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-whatsapp hover:bg-whatsapp-dark text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-line text-base"></i></span>
              WhatsApp ile Sor
            </a>
            <a
              href="tel:+905322376576"
              className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 hover:bg-white/20 text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line text-base"></i></span>
              Hemen Ara
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function NedenBizPage() {
  return (
    <main className="font-sans">
      <Navbar />
      <Hero />
      <AdvantagesSection />
      <TimelineSection />
      <CountriesSection />
      <Footer />
      <FloatingButtons />
    </main>
  );
}
